import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { ASSETS, LINKS } from "@/constants/assets";

const NAV_LINKS = [
  { href: "#services", label: "Services" },
  { href: "#domains", label: "Unified Medical Model" },
  { href: "#framework", label: "Evidence Based Protocols" },
  { href: "#archetypes", label: "Who We Serve" },
  { href: "#technology", label: "Technology" },
];

export const Navigation = ({ scrolled, mobileMenuOpen, setMobileMenuOpen }) => (
  <nav
    data-testid="main-navigation"
    className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${scrolled ? 'nav-scrolled' : ''} glass`}
  >
    <div className="max-w-[1440px] mx-auto px-6 lg:px-12 flex items-center justify-between h-[76px]">
      <a href="#" className="flex items-center gap-3.5 no-underline" data-testid="nav-logo">
        <img src={ASSETS.logo} alt="Limitless" className="h-[46px] w-[46px] rounded-full shadow-glow-cyan" />
        <div className="font-orbitron font-bold text-[16px] tracking-[3px] text-white text-shadow-sm">
          LIMITLESS
          <span className="block text-[9px] font-normal tracking-[4.5px] text-[#60A5FA] mt-0.5">
            Clinical Intelligence
          </span>
        </div>
      </a>

      <ul className="hidden lg:flex items-center gap-8 list-none">
        {NAV_LINKS.map((link) => (
          <li key={link.href}>
            <a
              href={link.href}
              className="font-outfit font-normal text-[14px] tracking-[1px] text-white/70 no-underline transition-colors hover:text-white relative group"
              data-testid={`nav-link-${link.label.toLowerCase()}`}
            >
              {link.label}
              <span className="absolute bottom-[-4px] left-0 w-0 h-[1.5px] bg-[#3B82F6] transition-all group-hover:w-full" />
            </a>
          </li>
        ))}
        <li>
          <a
            href={LINKS.jotform}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white text-[#030B18] px-7 py-2.5 rounded font-orbitron text-[10px] font-bold tracking-[2px] no-underline transition-all hover:shadow-glow-white hover:-translate-y-0.5"
            data-testid="nav-cta-button"
          >
            GET STARTED
          </a>
        </li>
      </ul>

      <button
        className="lg:hidden flex flex-col gap-[5px] p-2 bg-transparent border-none cursor-pointer"
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        data-testid="mobile-menu-toggle"
      >
        {mobileMenuOpen ? <X className="w-6 h-6 text-white" /> : <Menu className="w-6 h-6 text-white" />}
      </button>
    </div>

    <AnimatePresence>
      {mobileMenuOpen && (
        <motion.div
          className="mobile-menu-overlay lg:hidden"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <div className="flex flex-col items-center justify-center h-full gap-8">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="font-orbitron text-2xl font-bold tracking-[3px] text-white no-underline"
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <a
              href={LINKS.jotform}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary mt-4"
              onClick={() => setMobileMenuOpen(false)}
            >
              GET STARTED
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  </nav>
);
